if (!customElements.get("product-recently-view")) {
  customElements.define(
    "product-recently-view",
    class ProductRecentlyView extends HTMLElement {
      constructor() {
        super();
        this.carouselContainer = document.querySelector("[data-selector-recently-viewed]");
        this.sectionId = this.dataset.sectionId;
        this.slidesShow = 1 + Number(this.dataset.numberOfProducts);
        this.initCarousel();
      }

      async initCarousel() {
        const recentlyProduct = this.dataset.recentlyProduct;
        if (!recentlyProduct) return;
        var recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewedLM")) || [];
        recentlyViewed = recentlyViewed.slice(0, this.slidesShow);
        recentlyViewed = recentlyViewed.filter((item) => item !== recentlyProduct);

        if (recentlyViewed.length) {
          const actions = recentlyViewed.map(this._fetchData.bind(this));
          Promise.all(actions).then((ress) => {
            if (!ress.length) resolve();
            const isShowButton = ress.length > 4;
            const productCards = ress.join(" ");
            const lazyMarkup = this._renderCarousel(productCards, isShowButton);
            this.carouselContainer.innerHTML = lazyMarkup;
          });
        } else {
          this._removeSection();
        }
      }

      _fetchData(productHandle) {
        return new Promise((resolve) => {
          const requestUrl = `/products/${productHandle}?section_id=recently-viewed-product-item`;
          this._makeRequest("GET", requestUrl)
            .then((response) => {
              let sectionWrap = document.createElement("div");
              sectionWrap.innerHTML = response;
              const content = sectionWrap.querySelector(".slider__slide");
              const contentString = content ? content.outerHTML : "";
              resolve(contentString);
            })
            .catch(() => {
              console.error(`Recent product "${productHandle}" not found`);
              resolve();
            });
        });
      }

      _makeRequest(method, url) {
        return new Promise(function (resolve, reject) {
          let xhr = new XMLHttpRequest();
          xhr.open(method, url);
          xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
              resolve(xhr.response);
            } else {
              reject(new Error(this.status));
            }
          };
          xhr.onerror = function () {
            reject(new Error(this.status));
          };
          xhr.send();
        });
      }

      _renderCarousel(productCard, isShowButton) {
        const prevButton = isShowButton
          ? `
          <div class="slider-buttons left">
            <button
              type="button"
              class="slider-button slider-button--prev"
              name="previous"
              aria-label="{{ 'general.slider.previous_slide' | t }}"
              aria-controls="Slider-${this.sectionId}"
            ></button>
          </div>
        `
          : "";

        const nextButton = isShowButton
          ? `
          <div class="slider-buttons right">
            <button
              type="button"
              class="slider-button slider-button--next"
              name="next"
              aria-label="{{ 'general.slider.next_slide' | t }}"
              aria-controls="Slider-${this.sectionId}"
            ></button>
          </div>
        `
          : "";

        const dotPagination = isShowButton
          ? `
          <div class="slider-pagination"></div>
        `
          : "";
        return `
          <slider-component class="page-width slider-mobile-gutter scroll-trigger animate--slide-in"> 
            ${prevButton}
            <div
              id="Slider-${this.sectionId}"
              data-id="${this.sectionId}"
              class="grid product-grid contains-card contains-card--product grid--2-col grid--3-col-tablet grid--4-col-desktop slider slider--mobile slider--tablet slider--desktop"
              role="list"
              aria-label="{{ 'general.slider.name' | t }}"
              data-selector-recently-viewed
            > ${productCard} </div>
            ${nextButton}
            ${dotPagination}
          </slider-component>
        `;
      }

      _removeSection() {
        this.setAttribute("style", "display: none; padding: 0;");
      }
    }
  );
}
